package com.schoolconnect.app.feature.schoolusers.edit

private val editSchoolUserPhoneRegex = Regex("^(\\+91)?[6-9]\\d{9}$")
private val editSchoolUserEmailRegex = Regex("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$")

internal fun validateEditSchoolUser(values: EditSchoolUserFormValues): EditSchoolUserValidationErrors {
    fun required(value: String, message: String): String =
        if (value.trim().isBlank()) message else ""

    fun requiredPhone(value: String, message: String): String =
        if (value.trim().isBlank()) {
            message
        } else if (editSchoolUserPhoneRegex.matches(value.trim())) {
            ""
        } else {
            message
        }

    fun requiredEmail(value: String, message: String): String =
        if (value.trim().isBlank()) {
            message
        } else if (editSchoolUserEmailRegex.matches(value.trim())) {
            ""
        } else {
            message
        }

    return EditSchoolUserValidationErrors(
        staffId = required(values.staffId, "Staff ID is required"),
        fullName = required(values.fullName, "Full name is required"),
        staffRole = required(values.staffRole, "Staff role is required"),
        mobileNumber = requiredPhone(values.mobileNumber, "Enter a valid mobile number"),
        emailAddress = requiredEmail(values.emailAddress, "Enter a valid email address"),
        schoolId = required(values.schoolId, "School is required"),
        role = required(values.role, "Role is required"),
        gender = required(values.gender, "Gender is required"),
        status = required(values.status, "Status is required")
    )
}
